import { render, staticRenderFns } from "./QueryPuddingI.vue?vue&type=template&id=0b13ecdd&"
import script from "./QueryPuddingI.vue?vue&type=script&lang=js&"
export * from "./QueryPuddingI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports